import { GridDetailRowProps } from '@progress/kendo-react-grid';
import { GetString } from '../StringResourceManager';

export const AssetStateDetail = (props: GridDetailRowProps) => {
  const dataItem = props.dataItem;
  return (
    <div>
      <section style={{ width: '300px', float: 'left' }}>
        <p>
          <strong>{GetString('MANUFACTURER')}:</strong> {dataItem.Manufacturer}
        </p>
        <p>
          <strong>{GetString('COLUMN_TITLE_FIRMWARE_VERSION')}:</strong>{' '}
          {dataItem.FirmwareVersion}
        </p>
        <p>
          <strong>{GetString('SERIAL_NUMBER')}:</strong> {dataItem.SerialNumber}
        </p>
      </section>
    </div>
  );
};
